import React from 'react';
import { NumericFormat } from 'react-number-format';
import { InputAdornment, TextField } from '@mui/material';

import Icon from '../../Icon';

interface MaterialCurrencyFieldProps {
	name: string;
	value?: number;
	sendChange: (value: number | null) => void;
	disabled: boolean;
}

function MaterialCurrencyField({ name, value, sendChange, disabled }: MaterialCurrencyFieldProps) {
	function handleChange(event) {
		const newStringValue = event.target.value?.replaceAll('.', '').replace(',', '.');
		const newValue = newStringValue && newStringValue !== 0 ? newStringValue : null;
		sendChange(newValue);
	}

	return (
		<NumericFormat
			customInput={TextField}
			name={name}
			variant="outlined"
			size="small"
			fullWidth
			slotProps={{
				inputLabel: { shrink: true },
				input: {
					startAdornment: (
						<InputAdornment position="start">
							<Icon icon="currency-eur" size={18} />
						</InputAdornment>
					)
				}
			}}
			value={value ?? ''}
			disabled={disabled}
			onBlur={handleChange}
			thousandSeparator="."
			decimalSeparator=","
			decimalScale={2}
			fixedDecimalScale
		/>
	);
}

export default React.memo(MaterialCurrencyField);
